import React from 'react'
import LeieSearchView from './LeieSearchView'

const LeieSearch = ({ isQuickSearch = true, applicantId = '' }) => {
    return (
        <div className={`${!isQuickSearch ? 'm-3' : ''}`}>
            <LeieSearchView isQuickSearch={isQuickSearch} applicantId={applicantId} />
        </div>
    )
}

export default LeieSearch
